
/* eslint-disable max-len */
import {
  APIServer,
  APIDefaultHeaders,
  SDKOptions,
} from '../../typings/APIRequester';

import * as c from '../../typings/components';
import APIRequester from './APIRequester';

import {
  deliveryServer,
  getOfferDeadlinesParams,
  getShipmentMethodSuggestedPriceParams,
  getOperatorServicePointsParams,
  getTransactionsV2Params,
  postOptInRecommendationsParams,
  cacheKycForTier1AndReturnTier2UrlParams,
  acceptOrderParams,
  savePrivateSellerDac7DataParams,
  resetDac7Params,
  getSellerStatsParams,
  saveBusinessSellerDac7DataParams,
  rejectSafedealOrderParams,
  postKycRetryParams,
  getAdOfferEligibilityParams,
  getServicePointsParams,
  receiveSenditTrackingUpdatesParams,
  postPrivateSellerDac7DeclarationDataV1Params,
  getTransactionParams,
  uploadAttachmentParams,
  postSoleTraderSellerDac7DeclarationDataV1Params,
  getOrderPreviewPricev4Params,
  getCustomerSupportUserTransactionsParams,
  getOfferByAdIdAliasParams,
  deleteOfferByAdIdAliasParams,
  getOfferParams,
  putOfferParams,
  deleteOfferParams,
  getTransactionV2Params,
  postMarketpayOrderParams,
  forceOfferOptOutParams,
  getAdOfferEligibilityAliasParams,
  getDeeplinkingDataParams,
  postUserAddressParams,
  rejectOrderParams,
  postBillingDataParams,
  postContractParams,
  postBusinessSellerDac7DeclarationDataV1Params,
  postKycAccountV2Params,
  isStockAvailableParams,
  postMarketPayOfferV2Params,
  postMarketPayOfferParams,
  getOfferShipmentMethodsParams,
  rejectSafedealOrderV2Params,
  uploadOrderAttachmentParams,
  postFeedbackParams,
  getOfferByAdIdParams,
  deleteOfferByAdIdParams,
  getPackageCategoriesDetailsByCategoryParams,
  getServicePointParams,
  postAskForDeliveryParams,
  cancelTransactionParams,
  postReusableDataParams,
  getTransactionForCustomerSupportParams,
  postOperatorOutageParams,
  getSellerDac7StatusParams,
  postKycForTier1Params,
  getSuggestedCheckoutDataParams,
  getOfferV2Params,
  getSellerByOfferIdParams,
  customerSupportCancelParams,
  getOrderPreviewPricev3Params,
  getOfferOrderPreviewPriceParams,
  postKycAccountParams,
  postMarketpayOrderV3Params,
  postOrderParams,
  getOrderPreviewPriceByAdIdv4Params,
  getOrderPreviewPricev2Params,
  postMarketpayContractParams,
  getTransactionsParams,
  postOfferParams,
  getReusableDataV2Params,
  postReusableDataV2Params,
  getShipmentMethodSuggestedPriceHeader,
  getTransactionsV2Header,
  cacheKycForTier1AndReturnTier2UrlHeader,
  postKycRetryHeader,
  getAdOfferEligibilityHeader,
  getTransactionHeader,
  uploadAttachmentHeader,
  getOrderPreviewPricev4Header,
  getOfferByAdIdAliasHeader,
  getOfferHeader,
  putOfferHeader,
  getTransactionV2Header,
  postMarketpayOrderHeader,
  forceOfferOptOutHeader,
  getAdOfferEligibilityAliasHeader,
  getFeedbackReasonsHeader,
  getOfferEligibilityAliasHeader,
  rejectOrderHeader,
  postContractHeader,
  postKycAccountV2Header,
  isStockAvailableHeader,
  postMarketPayOfferV2Header,
  postMarketPayOfferHeader,
  getUserInvoicingInformationHeader,
  getOfferShipmentMethodsHeader,
  getKycRegistrationNeededHeader,
  uploadOrderAttachmentHeader,
  postFeedbackHeader,
  getOfferByAdIdHeader,
  getPackageCategoriesDetailsByCategoryHeader,
  postOperatorOutageHeader,
  postKycForTier1Header,
  getOfferV2Header,
  customerSupportCancelHeader,
  getKycStateForConfirmationHeader,
  getOrderPreviewPricev3Header,
  getOfferOrderPreviewPriceHeader,
  postKycAccountHeader,
  postMarketpayOrderV3Header,
  postOrderHeader,
  getOrderPreviewPriceByAdIdv4Header,
  getOrderPreviewPricev2Header,
  getKycAccountHeader,
  getKycHeader,
  getOfferEligibilityHeader,
  postMarketpayContractHeader,
  getTransactionsHeader,
  postOfferHeader
} from '../../typings/DeliverySDK';

/**
 * @namespace Delivery API Gateway SDK
 * @description Exposed specification via AWS API Gateway managed by Terraform
 * @see {@link https://git.naspersclassifieds.com/pay-and-ship/delivery/delivery-api-gateway/delivery-api-specification}
 * @class
 */
export default class DeliverySDK extends APIRequester {
  public version: string = 'v2.1.8';
  private serverMap:{ [index: string] : APIServer } = {
    "Server-1": {
        "url": "https://delivery-api.prd.01.eu-west-1.eu.olx.org",
        "basePath": ""
    }
};
  private serverPath: string;
  
  public constructor(serverName: deliveryServer, defaultHeaders: APIDefaultHeaders, options: SDKOptions = {}) {
    super(defaultHeaders);
    const { customUrl, customBasePath } = options;
    const { url, basePath } = this.serverMap[serverName];
    this.serverPath = DeliverySDK.parseAPIURL(customUrl || url, customBasePath || basePath);
  }
  
  
  /**
   * @name getOfferDeadlines
   * @public
   * @method
   */
  public async getOfferDeadlines (params: getOfferDeadlinesParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetOfferDeadlinesResponse> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}/deadlines`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getShipmentMethodSuggestedPrice
   * @public
   * @method
   */
  public async getShipmentMethodSuggestedPrice (params: getShipmentMethodSuggestedPriceParams, headers?:getShipmentMethodSuggestedPriceHeader, schemaType:string | null=null) : Promise<c.GetShipmentMethodSuggestedPriceResponse> {
    const {shipmentMethodId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/shipment-methods/${shipmentMethodId}/suggested-price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getOperatorServicePoints
   * @public
   * @method
   */
  public async getOperatorServicePoints (params: getOperatorServicePointsParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetOperatorServicePointsResponse> {
    const {operator, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/operators/${operator}/service-points`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getTransactionsV2
   * @public
   * @method
   */
  public async getTransactionsV2 (params: getTransactionsV2Params, headers?:getTransactionsV2Header, schemaType:string | null=null) : Promise<c.GetTransactionsResponseV2> {
    const {transactionType, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/transactions/${transactionType}`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name postOptInRecommendations
   * @public
   * @method
   */
  public async postOptInRecommendations (params: postOptInRecommendationsParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.PostOptInRecommendationsResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/opt-in/recommendations`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getSellerDac7Data
   * @public
   * @method
   */
  public async getSellerDac7Data (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.Dac7Response> {
    return this.fetchAPI(`${this.serverPath}/sellers/me/dac7`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name cacheKycForTier1AndReturnTier2Url
   * @public
   * @method
   */
  public async cacheKycForTier1AndReturnTier2Url (params: cacheKycForTier1AndReturnTier2UrlParams, headers?:cacheKycForTier1AndReturnTier2UrlHeader, schemaType:string | null=null) : Promise<c.SellerConfirmationFlowTier12Response> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v1/api/kyc/2/1`, 'PUT', body, headers, schemaType);
  }
  
  
  /**
   * @name acceptOrder
   * @public
   * @method
   */
  public async acceptOrder (params: acceptOrderParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/safedeal/order/${orderId}/accept`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name savePrivateSellerDac7Data
   * @public
   * @method
   */
  public async savePrivateSellerDac7Data (params: savePrivateSellerDac7DataParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/sellers/private/me/dac7`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name resetDac7
   * @public
   * @method
   */
  public async resetDac7 (params: resetDac7Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {id, } = params;
    return this.fetchAPI(`${this.serverPath}/sellers/${id}/dac7/reset`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name getSellerStats
   * @public
   * @method
   */
  public async getSellerStats (params: getSellerStatsParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetSellerStatsResponse> {
    const {id, } = params;
    return this.fetchAPI(`${this.serverPath}/sellers/${id}/stats`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name saveBusinessSellerDac7Data
   * @public
   * @method
   */
  public async saveBusinessSellerDac7Data (params: saveBusinessSellerDac7DataParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/sellers/business/me/dac7`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name rejectSafedealOrder
   * @public
   * @method
   */
  public async rejectSafedealOrder (params: rejectSafedealOrderParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, ...body } = params;
    return this.fetchAPI(`${this.serverPath}/safedeal/order/${orderId}/reject`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postKycRetry
   * @public
   * @method
   */
  public async postKycRetry (params: postKycRetryParams, headers?:postKycRetryHeader, schemaType:string | null=null) : Promise<c.KycStatusResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/kyc/retry`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getAdOfferEligibility
   * @public
   * @method
   */
  public async getAdOfferEligibility (params: getAdOfferEligibilityParams, headers?:getAdOfferEligibilityHeader, schemaType:string | null=null) : Promise<c.AdOfferEligibility> {
    const {adId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/ads/${adId}/offer-eligibility`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getServicePoints
   * @public
   * @method
   */
  public async getServicePoints (params: getServicePointsParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetNearByServicePointsResponse> {
    const { ...query } = params;
    return this.fetchAPI(`${this.serverPath}/service-points`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getPackageCategories
   * @public
   * @method
   */
  public async getPackageCategories (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetPackageCategoriesResponse> {
    return this.fetchAPI(`${this.serverPath}/package-categories`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name receiveSenditTrackingUpdates
   * @public
   * @method
   */
  public async receiveSenditTrackingUpdates (params: receiveSenditTrackingUpdatesParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {value, } = params;
    return this.fetchAPI(`${this.serverPath}/shipments/hooks/${value}`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name postPrivateSellerDac7DeclarationDataV1
   * @public
   * @method
   */
  public async postPrivateSellerDac7DeclarationDataV1 (params: postPrivateSellerDac7DeclarationDataV1Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.Dac7SubmitResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v1/sellers/private/me/dac7`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getTransaction
   * @public
   * @method
   */
  public async getTransaction (params: getTransactionParams, headers?:getTransactionHeader, schemaType:string | null=null) : Promise<c.GetTransactionResponse> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/transactions/${orderId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name uploadAttachment
   * @public
   * @method
   */
  public async uploadAttachment (params: uploadAttachmentParams, headers?:uploadAttachmentHeader, schemaType:string | null=null) : Promise<c.UploadAttachmentResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/safedeal/attachment/upload`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postSoleTraderSellerDac7DeclarationDataV1
   * @public
   * @method
   */
  public async postSoleTraderSellerDac7DeclarationDataV1 (params: postSoleTraderSellerDac7DeclarationDataV1Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.Dac7SubmitResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v1/sellers/sole-trader/me/dac7`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getOrderPreviewPricev4
   * @public
   * @method
   */
  public async getOrderPreviewPricev4 (params: getOrderPreviewPricev4Params, headers?:getOrderPreviewPricev4Header, schemaType:string | null=null) : Promise<c.OrderPreviewPriceResponseV4> {
    const {offerId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v4/offers/${offerId}/order-preview/price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getCustomerSupportUserTransactions
   * @public
   * @method
   */
  public async getCustomerSupportUserTransactions (params: getCustomerSupportUserTransactionsParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetTransactionsResponse> {
    const {userId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/customer-support/user/${userId}/transactions`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getOfferByAdIdAlias
   * @public
   * @method
   */
  public async getOfferByAdIdAlias (params: getOfferByAdIdAliasParams, headers?:getOfferByAdIdAliasHeader, schemaType:string | null=null) : Promise<c.GetOfferResponseV2> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/sda/${adId}/offer`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name deleteOfferByAdIdAlias
   * @public
   * @method
   */
  public async deleteOfferByAdIdAlias (params: deleteOfferByAdIdAliasParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/sda/${adId}/offer`, 'DELETE', null, headers, schemaType);
  }
  
  
  /**
   * @name getOffer
   * @public
   * @method
   */
  public async getOffer (params: getOfferParams, headers?:getOfferHeader, schemaType:string | null=null) : Promise<c.GetOfferResponse> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name putOffer
   * @public
   * @method
   */
  public async putOffer (params: putOfferParams, headers?:putOfferHeader, schemaType:string | null=null) : Promise<c.PutOfferResponse> {
    const {offerId, ...body } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}`, 'PUT', body, headers, schemaType);
  }
  
  
  /**
   * @name deleteOffer
   * @public
   * @method
   */
  public async deleteOffer (params: deleteOfferParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}`, 'DELETE', null, headers, schemaType);
  }
  
  
  /**
   * @name getTransactionV2
   * @public
   * @method
   */
  public async getTransactionV2 (params: getTransactionV2Params, headers?:getTransactionV2Header, schemaType:string | null=null) : Promise<c.GetTransactionResponseV2> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/v2/transactions/${orderId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postMarketpayOrder
   * @public
   * @method
   */
  public async postMarketpayOrder (params: postMarketpayOrderParams, headers?:postMarketpayOrderHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/orders`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name forceOfferOptOut
   * @public
   * @method
   */
  public async forceOfferOptOut (params: forceOfferOptOutParams, headers?:forceOfferOptOutHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/ad/${adId}/offer/forced`, 'DELETE', null, headers, schemaType);
  }
  
  
  /**
   * @name getAdOfferEligibilityAlias
   * @public
   * @method
   */
  public async getAdOfferEligibilityAlias (params: getAdOfferEligibilityAliasParams, headers?:getAdOfferEligibilityAliasHeader, schemaType:string | null=null) : Promise<c.AdOfferEligibility> {
    const {adId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/sda/${adId}/offer-eligibility`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getDeeplinkingData
   * @public
   * @method
   */
  public async getDeeplinkingData (params: getDeeplinkingDataParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.DeepLinkData> {
    const { ...query } = params;
    return this.fetchAPI(`${this.serverPath}/deep-links`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getFeedbackReasons
   * @public
   * @method
   */
  public async getFeedbackReasons (params: void, headers?:getFeedbackReasonsHeader, schemaType:string | null=null) : Promise<c.GetFeedbackReasonsResponse> {
    return this.fetchAPI(`${this.serverPath}/buyer/feedback/reasons`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postUserAddress
   * @public
   * @method
   */
  public async postUserAddress (params: postUserAddressParams, headers?:Partial<HeadersInit>, schemaType:string="address") : Promise<c.PostUserAddressResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/users/me/addresses`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getOfferEligibilityAlias
   * @public
   * @method
   */
  public async getOfferEligibilityAlias (params: void, headers?:getOfferEligibilityAliasHeader, schemaType:string | null=null) : Promise<c.AdEligibilityRequirements> {
    return this.fetchAPI(`${this.serverPath}/sda/offer-eligibility`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name rejectOrder
   * @public
   * @method
   */
  public async rejectOrder (params: rejectOrderParams, headers?:rejectOrderHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/orders/${orderId}/reject`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name postBillingData
   * @public
   * @method
   */
  public async postBillingData (params: postBillingDataParams, headers?:Partial<HeadersInit>, schemaType:string="billing") : Promise<c.PostReusableDataResponse> {
    const {orderID, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/users/me/addresses/billing/${orderID}`, 'POST', query, headers, schemaType);
  }
  
  
  /**
   * @name getMarketpayWhitelistedUser
   * @public
   * @method
   */
  public async getMarketpayWhitelistedUser (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    return this.fetchAPI(`${this.serverPath}/v2/marketpay-user`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postContract
   * @public
   * @method
   */
  public async postContract (params: postContractParams, headers?:postContractHeader, schemaType:string | null=null) : Promise<c.PostContractResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/contracts`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postBusinessSellerDac7DeclarationDataV1
   * @public
   * @method
   */
  public async postBusinessSellerDac7DeclarationDataV1 (params: postBusinessSellerDac7DeclarationDataV1Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.Dac7SubmitResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v1/sellers/business/me/dac7`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postKycAccountV2
   * @public
   * @method
   */
  public async postKycAccountV2 (params: postKycAccountV2Params, headers?:postKycAccountV2Header, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/kyc/v2/account`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name isStockAvailable
   * @public
   * @method
   */
  public async isStockAvailable (params: isStockAvailableParams, headers?:isStockAvailableHeader, schemaType:string | null=null) : Promise<c.StockAvailabilityForOffer> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/inventory/is-stock-available/${adId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postMarketPayOfferV2
   * @public
   * @method
   */
  public async postMarketPayOfferV2 (params: postMarketPayOfferV2Params, headers?:postMarketPayOfferV2Header, schemaType:string | null=null) : Promise<c.PostOfferResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v3/offers`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postMarketPayOffer
   * @public
   * @method
   */
  public async postMarketPayOffer (params: postMarketPayOfferParams, headers?:postMarketPayOfferHeader, schemaType:string | null=null) : Promise<c.PostOfferResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/offers`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getUserInvoicingInformation
   * @public
   * @method
   */
  public async getUserInvoicingInformation (params: void, headers?:getUserInvoicingInformationHeader, schemaType:string | null=null) : Promise<c.InvoicingResponse> {
    return this.fetchAPI(`${this.serverPath}/v1/api/kyc/invoicing`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getOfferShipmentMethods
   * @public
   * @method
   */
  public async getOfferShipmentMethods (params: getOfferShipmentMethodsParams, headers?:getOfferShipmentMethodsHeader, schemaType:string | null=null) : Promise<c.GetOfferShipmentMethodsResponse> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}/shipment-methods`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getKycRegistrationNeeded
   * @public
   * @method
   */
  public async getKycRegistrationNeeded (params: void, headers?:getKycRegistrationNeededHeader, schemaType:string | null=null) : Promise<c.KycRegistrationNeededResponse> {
    return this.fetchAPI(`${this.serverPath}/v1/api/kyc/registration-needed`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name rejectSafedealOrderV2
   * @public
   * @method
   */
  public async rejectSafedealOrderV2 (params: rejectSafedealOrderV2Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, ...body } = params;
    return this.fetchAPI(`${this.serverPath}/safedeal/v2/order/${orderId}/reject`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name uploadOrderAttachment
   * @public
   * @method
   */
  public async uploadOrderAttachment (params: uploadOrderAttachmentParams, headers?:uploadOrderAttachmentHeader, schemaType:string | null=null) : Promise<c.UploadAttachmentResponse> {
    const {orderId, ...body } = params;
    return this.fetchAPI(`${this.serverPath}/safedeal/order/${orderId}/attachment`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postFeedback
   * @public
   * @method
   */
  public async postFeedback (params: postFeedbackParams, headers?:postFeedbackHeader, schemaType:string | null=null) : Promise<c.CreateFeedbackResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/buyer/feedback`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getOfferByAdId
   * @public
   * @method
   */
  public async getOfferByAdId (params: getOfferByAdIdParams, headers?:getOfferByAdIdHeader, schemaType:string | null=null) : Promise<c.GetOfferResponseV2> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/ads/${adId}/offer`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name deleteOfferByAdId
   * @public
   * @method
   */
  public async deleteOfferByAdId (params: deleteOfferByAdIdParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/ads/${adId}/offer`, 'DELETE', null, headers, schemaType);
  }
  
  
  /**
   * @name getPackageCategoriesDetailsByCategory
   * @public
   * @method
   */
  public async getPackageCategoriesDetailsByCategory (params: getPackageCategoriesDetailsByCategoryParams, headers?:getPackageCategoriesDetailsByCategoryHeader, schemaType:string | null=null) : Promise<c.GetPackageCategoriesDetailsResponse> {
    const {adCategoryId, } = params;
    return this.fetchAPI(`${this.serverPath}/package-categories/${adCategoryId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getServicePoint
   * @public
   * @method
   */
  public async getServicePoint (params: getServicePointParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetServicePointResponse> {
    const {pointId, } = params;
    return this.fetchAPI(`${this.serverPath}/service-points/${pointId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postAskForDelivery
   * @public
   * @method
   */
  public async postAskForDelivery (params: postAskForDeliveryParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {adId, } = params;
    return this.fetchAPI(`${this.serverPath}/ask-for-delivery/${adId}`, 'PUT', null, headers, schemaType);
  }
  
  
  /**
   * @name cancelTransaction
   * @public
   * @method
   */
  public async cancelTransaction (params: cancelTransactionParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/transactions/${orderId}/cancel`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name getReusableData
   * @public
   * @method
   */
  public async getReusableData (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetReusableDataResponse> {
    return this.fetchAPI(`${this.serverPath}/users/me/addresses/reusable`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postReusableData
   * @public
   * @method
   */
  public async postReusableData (params: postReusableDataParams, headers?:Partial<HeadersInit>, schemaType:string=null) : Promise<c.PostReusableDataResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/users/me/addresses/reusable`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getLastBillingData
   * @public
   * @method
   */
  public async getLastBillingData (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetUserBillingResponse> {
    return this.fetchAPI(`${this.serverPath}/users/me/addresses/billing`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getTransactionForCustomerSupport
   * @public
   * @method
   */
  public async getTransactionForCustomerSupport (params: getTransactionForCustomerSupportParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetTransactionResponse> {
    const {searchKey, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/customer-support/transactions/${searchKey}`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name postOperatorOutage
   * @public
   * @method
   */
  public async postOperatorOutage (params: postOperatorOutageParams, headers?:postOperatorOutageHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/operator/outage`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getSellerDac7Status
   * @public
   * @method
   */
  public async getSellerDac7Status (params: getSellerDac7StatusParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetDac7StatusResponse> {
    const {id, } = params;
    return this.fetchAPI(`${this.serverPath}/sellers/${id}/dac7/status`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getUserContactData
   * @public
   * @method
   */
  public async getUserContactData (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetUserContactDataResponse> {
    return this.fetchAPI(`${this.serverPath}/users/me/contact`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postKycForTier1
   * @public
   * @method
   */
  public async postKycForTier1 (params: postKycForTier1Params, headers?:postKycForTier1Header, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v1/api/kyc/1`, 'PUT', body, headers, schemaType);
  }
  
  
  /**
   * @name getSuggestedCheckoutData
   * @public
   * @method
   */
  public async getSuggestedCheckoutData (params: getSuggestedCheckoutDataParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetSuggestedCheckoutDataResponse> {
    const { ...query } = params;
    return this.fetchAPI(`${this.serverPath}/users/me/suggested-checkout-data`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getOfferV2
   * @public
   * @method
   */
  public async getOfferV2 (params: getOfferV2Params, headers?:getOfferV2Header, schemaType:string | null=null) : Promise<c.GetOfferResponseV2> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/v2/offers/${offerId}`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getSellerByOfferId
   * @public
   * @method
   */
  public async getSellerByOfferId (params: getSellerByOfferIdParams, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetSellerResponseV1> {
    const {offerId, } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}/seller`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name customerSupportCancel
   * @public
   * @method
   */
  public async customerSupportCancel (params: customerSupportCancelParams, headers?:customerSupportCancelHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const {orderId, } = params;
    return this.fetchAPI(`${this.serverPath}/customer-support/${orderId}/cancel`, 'POST', null, headers, schemaType);
  }
  
  
  /**
   * @name getKycStateForConfirmation
   * @public
   * @method
   */
  public async getKycStateForConfirmation (params: void, headers?:getKycStateForConfirmationHeader, schemaType:string | null=null) : Promise<c.KycConfirmationResponse> {
    return this.fetchAPI(`${this.serverPath}/v1/api/kyc/confirm`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getOrderPreviewPricev3
   * @public
   * @method
   */
  public async getOrderPreviewPricev3 (params: getOrderPreviewPricev3Params, headers?:getOrderPreviewPricev3Header, schemaType:string | null=null) : Promise<c.OrderPreviewPriceResponseV3> {
    const {offerId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v3/offers/${offerId}/order-preview/price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getOfferOrderPreviewPrice
   * @public
   * @method
   */
  public async getOfferOrderPreviewPrice (params: getOfferOrderPreviewPriceParams, headers?:getOfferOrderPreviewPriceHeader, schemaType:string | null=null) : Promise<c.GetOfferOrderPreviewPriceResponse> {
    const {offerId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/offers/${offerId}/order-preview/price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getSellerDac7DataV1
   * @public
   * @method
   */
  public async getSellerDac7DataV1 (params: void, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetDac7DeclarationDataV1> {
    return this.fetchAPI(`${this.serverPath}/v1/sellers/me/dac7`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postKycAccount
   * @public
   * @method
   */
  public async postKycAccount (params: postKycAccountParams, headers?:postKycAccountHeader, schemaType:string | null=null) : Promise<Record<string, any>> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/kyc/account`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postMarketpayOrderV3
   * @public
   * @method
   */
  public async postMarketpayOrderV3 (params: postMarketpayOrderV3Params, headers?:postMarketpayOrderV3Header, schemaType:string | null=null) : Promise<c.PostOrderMarketpayResponseV3> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v3/orders`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name postOrder
   * @public
   * @method
   */
  public async postOrder (params: postOrderParams, headers?:postOrderHeader, schemaType:string | null=null) : Promise<c.PostOrderResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/orders`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getOrderPreviewPriceByAdIdv4
   * @public
   * @method
   */
  public async getOrderPreviewPriceByAdIdv4 (params: getOrderPreviewPriceByAdIdv4Params, headers?:getOrderPreviewPriceByAdIdv4Header, schemaType:string | null=null) : Promise<c.OrderPreviewPriceResponseV4> {
    const {adId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v4/ad/${adId}/order-preview/price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getOrderPreviewPricev2
   * @public
   * @method
   */
  public async getOrderPreviewPricev2 (params: getOrderPreviewPricev2Params, headers?:getOrderPreviewPricev2Header, schemaType:string | null=null) : Promise<c.GetOrderPreviewPriceResponseV2> {
    const {offerId, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v2/offers/${offerId}/order-preview/price`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name getKycAccount
   * @public
   * @method
   */
  public async getKycAccount (params: void, headers?:getKycAccountHeader, schemaType:string | null=null) : Promise<c.KycStatusResponse> {
    return this.fetchAPI(`${this.serverPath}/v2/users/me/kyc/status`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getKyc
   * @public
   * @method
   */
  public async getKyc (params: void, headers?:getKycHeader, schemaType:string | null=null) : Promise<c.KycResultResponse> {
    return this.fetchAPI(`${this.serverPath}/v2/users/me/kyc`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name getOfferEligibility
   * @public
   * @method
   */
  public async getOfferEligibility (params: void, headers?:getOfferEligibilityHeader, schemaType:string | null=null) : Promise<c.AdEligibilityRequirements> {
    return this.fetchAPI(`${this.serverPath}/ads/offer-eligibility`, 'GET', null, headers, schemaType);
  }
  
  
  /**
   * @name postMarketpayContract
   * @public
   * @method
   */
  public async postMarketpayContract (params: postMarketpayContractParams, headers?:postMarketpayContractHeader, schemaType:string | null=null) : Promise<c.PostContractResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/contracts`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getTransactions
   * @public
   * @method
   */
  public async getTransactions (params: getTransactionsParams, headers?:getTransactionsHeader, schemaType:string | null=null) : Promise<c.GetTransactionsResponse> {
    const {transactionType, ...query } = params;
    return this.fetchAPI(`${this.serverPath}/users/me/transactions/${transactionType}`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name postOffer
   * @public
   * @method
   */
  public async postOffer (params: postOfferParams, headers?:postOfferHeader, schemaType:string | null=null) : Promise<c.PostOfferResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/offers`, 'POST', body, headers, schemaType);
  }
  
  
  /**
   * @name getReusableDataV2
   * @public
   * @method
   */
  public async getReusableDataV2 (params: getReusableDataV2Params, headers?:Partial<HeadersInit>, schemaType:string | null=null) : Promise<c.GetUserAddressResponseV2> {
    const { ...query } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/addresses/reusable`, 'GET', query, headers, schemaType);
  }
  
  
  /**
   * @name postReusableDataV2
   * @public
   * @method
   */
  public async postReusableDataV2 (params: postReusableDataV2Params, headers?:Partial<HeadersInit>, schemaType:string=null) : Promise<c.PostReusableDataResponse> {
    const { ...body } = params;
    return this.fetchAPI(`${this.serverPath}/v2/users/me/addresses/reusable`, 'POST', body, headers, schemaType);
  }
}
